import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Smartphone } from 'lucide-react';

let deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new Event('pwa-installable'));
});

export default function InstallAppButton({ className = '' }) {
  const navigate = useNavigate();
  const [, setInstallable] = useState(!!deferredPrompt);

  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

  useEffect(() => {
    const onInstallable = () => setInstallable(true);
    window.addEventListener('pwa-installable', onInstallable);
    return () => window.removeEventListener('pwa-installable', onInstallable);
  }, []);

  if (isStandalone) return null;

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      deferredPrompt = null;
      setInstallable(false);
    } else {
      navigate('/install');
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={install} className={className} data-testid="install-app-btn">
      <Smartphone className="w-4 h-4 mr-1.5" /> Get the App
    </Button>
  );
}
